import request from '@/utils/request'

let CropApi = {

  /*分类管理*/
  cropList (data, errorback) {
    return request._post('/shop/product/crop/index', data, errorback)
  },

  /*分类管理*/
  cropListByParentId (data, errorback) {
    return request._postBody('/shop/product/crop/parent/index', data, errorback)
  },
  /*分类添加*/
  cropAdd (data, errorback) {
    return request._postBody('/shop/product/crop/add', data, errorback)
  },
  /*分类删除*/
  cropDel (data, errorback) {
    return request._post('/shop/product/crop/delete', data, errorback)
  },
  /*分类修改*/
  cropEdit (data, errorback) {
    return request._postBody('/shop/product/crop/edit', data, errorback)
  },

  cropImageAdd (data, errorback) {
    return request._postBody('/shop/product/crop/image/add', data, errorback)
  },
  cropImageList (data, errorback) {
    return request._postBody('/shop/product/crop/image/index', data, errorback)
  },
  cropImageDel (data, errorback) {
    return request._post('/shop/product/crop/image/delete', data, errorback)
  },
  draggeCropImage (data, errorback) {
    return request._postBody('/shop/product/crop/image/dragge', data, errorback)
  }
}

export default CropApi



// WEBPACK FOOTER //
// ./src/api/crop.js